import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import zh from './zh-cn'
import en from './en'

const messages = {
  'zh-cn': zh,
  'en': en
}
const locale = localStorage.getItem('locale') || 'zh-cn'
const i18n = new VueI18n({ locale, messages })
export default i18n